import { useEffect, useRef, useState } from "react";
import RightSidebar from "./RightSidebar";
import { setHitterCanvas, setPitcherCanvas } from "../Utils/canvas";
import { useSelector } from "react-redux";
import visualAngle from "../data/visualAngle.json";
import playModeData from "../data/playMode.json";
import { ValueMap } from "../Utils/DataProcess2";
import DisplayVideo from "./DisplayVideo/SingleVideo";
import SyncVideoPlayer from "./DisplayVideo/SyncVideo";
import {
  videoStore,
  set_Video_idx,
  set_Video1_DisplayAngle,
  set_Video1_DisplaySRC,
  set_PlayMode,
} from "../state/videoSlice";

import {
  CategoryScale,
  LinearScale,
  BubbleController,
  PointElement,
} from "chart.js";

import Chart from "chart.js/auto";
import OverlapVideo from "./DisplayVideo/OverlapVideo";
Chart.register(CategoryScale, LinearScale, BubbleController, PointElement);

const PlayMode = ({ playMode, handleButtonClick, index }) => {
  const _playMode = useSelector((state) => state.playmode);

  return (
    <div
      className={`btn_video_pos ${playModeData[_playMode - 1] === playMode ? "btn_filmroom_list" : "btn_filmroom_listr"}`}
      onClick={() => handleButtonClick(playModeData.indexOf(playMode) + 1)}
      pos={index + 1}
    >
      {playMode}
    </div>
  );
};

const View = ({ videos, setLoading }) => {
  const displayData = useSelector((state) => state);
  const rightsidebarRef = useRef(null);
  const [videoFound, setVideoFound] = useState(true);
  const [selectVideos, setSelectVideos] = useState([]);

  const handleButtonClick = async (playMode) => {
    console.log(playMode);
    if (rightsidebarRef.current) {
      videoStore.dispatch(set_PlayMode(playMode));
      setVideoFound(true);
      // rightsidebarRef.current.handleButtonClick(view);
    }
  };

  const handleVideoError = () => {
    setVideoFound(false);
  };

  const downLoadVideo = async (src, video_object_key) => {
    try {
      const response = await fetch(src + video_object_key, {
        mode: "cors",
      });
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = video_object_key || "video.mp4";
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.log("DownLoad Error", err);
    }
    return;
  };

  useEffect(() => {
    console.log(displayData);
    setVideoFound(true);
    setLoading(true);
    const hitData = {
      [ValueMap.TagPList[displayData.video1.pitching_type]]: [
        displayData.video1.batter_xy,
      ],
    };

    const pitchData = {
      [ValueMap.TagPList[displayData.video1.pitching_type]]: [
        displayData.video1.pitcher_xy,
      ],
    };

    const pitchGraph = setPitcherCanvas("20210801", pitchData);
    const hitterGraph = setHitterCanvas("20210804", hitData);
    setLoading(false);

    if (displayData.playmode === 2 && displayData.video1) {
      setSelectVideos([
        displayData.video1.src + displayData.video1.video_object_key,
        visualAngle["本後正面"] + displayData.video1.video_object_key,
        visualAngle["打者一壘側"] + displayData.video1.video_object_key,
        visualAngle["投手一壘側"] + displayData.video1.video_object_key,
      ]);
    }

    if (displayData.playmode === 3) {
      const currentIdx = videoStore.getState().idx;
      if (selectVideos.length === 4) {
        const copySelectVideos = [...selectVideos];
        if (currentIdx === 0)
          copySelectVideos[displayData.idx] =
            displayData.video1.src + displayData.video1.video_object_key;
        if (currentIdx === 1)
          copySelectVideos[displayData.idx] =
            displayData.video2.src + displayData.video2.video_object_key;
        setSelectVideos(copySelectVideos);
      } else {
        if (currentIdx === 0)
          setSelectVideos([
            displayData.video1.src + displayData.video1.video_object_key,
          ]);
        if (currentIdx === 1)
          setSelectVideos([
            ...selectVideos,
            displayData.video2.src + displayData.video2.video_object_key,
          ]);
      }
      videoStore.dispatch(set_Video_idx((currentIdx + 1) % 2));
    }

    if (displayData.playmode === 4) {
      setSelectVideos([
        displayData.video1.src + displayData.video1.video_object_key,
        visualAngle["本後正面"] + displayData.video1.video_object_key,
      ]);
    }

    return () => {
      pitchGraph.destroy();
      hitterGraph.destroy();
    };
  }, [displayData.video1, displayData.playmode]);

  return (
    <div className="filmroom">
      <div className="filmroom_video">
        {displayData.playmode === 1 && (
          <DisplayVideo videoFound={videoFound} displayData={displayData} />
        )}
        {displayData.playmode === 2 && (
          <SyncVideoPlayer videoUrls={selectVideos} />
        )}
        {displayData.playmode === 3 && (
          <DisplayVideo videoFound={videoFound} displayData={displayData} />
        )}
        {displayData.playmode === 4 && (
          <OverlapVideo videoFound={videoFound} videoUrls={selectVideos} />
        )}

        <div className="filmroom_info">
          <div className="filmroom_infobox">
            <div className="filmroom_infobox_block">
              <div className="filmroom_infobox_title">
                {displayData.video1.title}
              </div>
              <div className="filmroom_infobox_vs">
                主隊：{displayData.video1.team1 || "[未提供]"} 客隊：
                {displayData.video1.team2 || "[未提供]"}
              </div>
              <div className="filmroom_infobox_date">
                錄製時間：{displayData.video1.date || "[未提供]"}
              </div>
            </div>

            <div className="filmroom_infobox_stat">
              <div className="stat_no">{displayData.video1.stat_no}</div>
              <div className="stat_map">
                <div className="filmroom_eachball_block">
                  {
                    <div
                      className={`filmroom_eachball_diamond filmroom_eachball_diamond1  ${displayData.video1.onBase[0] && "diamond_highlight"}`}
                    ></div>
                  }
                  {
                    <div
                      className={`filmroom_eachball_diamond filmroom_eachball_diamond2 ${displayData.video1.onBase[1] && "diamond_highlight"} `}
                    ></div>
                  }
                  {
                    <div
                      className={`filmroom_eachball_diamond filmroom_eachball_diamond3 ${displayData.video1.onBase[2] && "diamond_highlight"} `}
                    ></div>
                  }
                </div>
              </div>
              <div className="stat_info">{displayData.video1.stat_info}</div>
            </div>
            <div className="clear"></div>
            <div className="filmroom_perspective">
              {playModeData.map((playMode, index) => (
                <PlayMode
                  key={index}
                  index={index}
                  playMode={playMode}
                  handleButtonClick={handleButtonClick}
                />
              ))}
              <div
                className="btn_download"
                title="downloadVideo"
                onClick={() =>
                  downLoadVideo(
                    displayData.video1.src,
                    displayData.video1.video_object_key,
                  )
                }
              ></div>
            </div>
          </div>
          <div className="clear"></div>
        </div>

        <div className="filmroom_ballinfo">
          <div className="filmroom_ballinfo_block">
            <div className="filmroom_pitcher">
              投手 <span className="team_name">{displayData.video1.team1}</span>
              <br />
              {displayData.video1.pitcher_number}{" "}
              <span className="pitcher_name">{displayData.video1.pitcher}</span>
              <br />
              {displayData.video1.pitcherhand}
            </div>
            <div className="filmroom_pitcher_info">
              球&emsp;&emsp;種：<span>{displayData.video1.pitching_type}</span>
              <br />
              球&emsp;&emsp;速：<span>{displayData.video1.pitching_speed}</span>
              <br />
              投球結果：<span>{displayData.video1.pitching_results}</span>
            </div>
          </div>
          <div className="filmroom_ballinfo_block">
            <div className="filmroom_hitter">
              打者 <span className="team_name">{displayData.video1.team2}</span>
              <br />
              {displayData.video1.hitter_number}{" "}
              <span className="hitter_name">{displayData.video1.hitter}</span>
              <br />
              {displayData.video1.hitterhand}
            </div>
            <div className="filmroom_hitter_info">
              擊&emsp;&emsp;出：
              <span>{displayData.video1.batting_results || "..."}</span>
              <br />
              球&emsp;&emsp;種：<span>{displayData.video1.pitching_type}</span>
              <br />
              初&emsp;&emsp;速：<span>{displayData.video1.batting_speed}</span>
              &emsp;仰角：<span>{displayData.video1.batting_angle}</span>
            </div>
          </div>
        </div>

        <div className="filmroom_inbase">
          <div className="eachhitter_pitcher">
            <canvas className="pitcher_canvas" name="20210801"></canvas>
          </div>
        </div>
        <div className="filmroom_eachhitter">
          <div className="eachhitter_hitter">
            <canvas className="hitter_canvas" name="20210804"></canvas>
          </div>
        </div>
        <div className="clear"></div>
      </div>

      {/* <!-- right side bar --> */}
      <RightSidebar
        ref={rightsidebarRef}
        videos={videos}
        setLoading={setLoading}
      />
    </div>
  );
};

export default View;
